import React from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { convertTimestringToFormat, API_TIME_FORMAT } from 'helpers/timeFormat';

import themeable from 'zignal-landscape/lib/themeable';
import { TR, TD } from 'zignal-landscape/lib/Table';

import TableIcon from 'components/TableIcon';

import LockOpenIcon from 'zignal-landscape/lib/Icon/LockOpenIcon';
import LockClosedIcon from 'zignal-landscape/lib/Icon/LockClosedIcon';
import CopyIcon from 'zignal-landscape/lib/Icon/CopyIcon';
import TrashIcon from 'zignal-landscape/lib/Icon/TrashIcon';
import RefreshIcon from 'zignal-landscape/lib/Icon/RefreshIcon';

// eslint-disable-next-line complexity
const SharedLinkRow = (props) => {
  const { key, token={}, userId, isCampaignAdmin, updatingSharedToken, successText, timezone,
    updateSharedToken, confirmDeleteSharedToken, mouseLeaveIcon, clickIcon, clickedIcon, styles={} } = props;
  const {
    path='', shortUrl='', createdBy={}, createdAt, expiresAt, active
  } = token;
  let { name } = token;
  if(token.typeId) {
    name = token.typeId.data.title;
  }
  const { _id: createdByUserId, first_name: firstName, last_name: lastName } = createdBy;
  const userIsCreator = createdByUserId === userId;
  const notAuthorized = !(userIsCreator || isCampaignAdmin);
  // user must either be the creator or have a role >= campaign admin to edit/delete
  const displayName = userIsCreator ? 'Me' : `${firstName || ''} ${lastName || ''}`;
  const dashboardPath = `${window.location.origin || 'https://client.zignallabs.com' }${path || ''}`;
  const format = 'M/D/YY';
  const createdAtFormatted = convertTimestringToFormat(createdAt, format, timezone, '--');
  const expiresAtFormatted = convertTimestringToFormat(expiresAt, format, timezone, 'No Expiration');

  return (
    <TR key={key}>
      <TD>
        <a className={classnames(styles.sharedLink, styles.link)} href={dashboardPath}>
          <div className={styles.ellipsis}>{name}</div>
        </a>
      </TD>
      <TD>
        <a
          className={classnames(styles.sharedLink, styles.link)}
          href={shortUrl} target="_blank"
          rel="noopener noreferrer"
        >
          <div className={classnames(styles.ellipsis, styles.ellipsis200)}>{shortUrl}</div>
        </a>
      </TD>
      <TD>
        <div className={styles.ellipsis}>{displayName}</div>
      </TD>
      <TD>{createdAtFormatted}</TD>
      <TD>{expiresAtFormatted}</TD>
      <TD>
        <TableIcon
          tooltipText={`Click to ${active ? 'disable' : 'enable'} access`}
          successText={successText}
          notAuthorized={notAuthorized}
          onClick={updatingSharedToken ? noop : () => {
            updateSharedToken(Object.assign({}, token, { active: !active }));
          }}
          onMouseLeave={mouseLeaveIcon}
        >
          {active ? <LockOpenIcon /> : <LockClosedIcon />}
        </TableIcon>
        <TableIcon
          tooltipText="Extend expiration date"
          successText={successText}
          notAuthorized={notAuthorized}
          onClick={updatingSharedToken ? noop : () => {
            updateSharedToken(Object.assign({}, token, {expiresAt: moment().add(1, 'months').utc().format(API_TIME_FORMAT)}));
          }}
          onMouseLeave={mouseLeaveIcon}
        >
          <RefreshIcon />
        </TableIcon>
        <TableIcon
          tooltipText="Copy to clipboard"
          successText={clickedIcon && 'Copied to clipboard'}
          onClick={clickedIcon ? noop : () => {
            copy(`${shortUrl}`);
            clickIcon();
          }}
          onMouseLeave={mouseLeaveIcon}
        >
          <CopyIcon />
        </TableIcon>
        <TableIcon
          tooltipText="Delete Dashboard Link"
          notAuthorized={notAuthorized}
          onClick={() => confirmDeleteSharedToken(token)}
        >
          <TrashIcon />
        </TableIcon>
      </TD>
    </TR>
  );
};

SharedLinkRow.propTypes = {
  key: PropTypes.string,
  token: PropTypes.object,
  userId: PropTypes.string,
  isCampaignAdmin: PropTypes.bool,
  updatingSharedToken: PropTypes.bool,
  updateSharedToken: PropTypes.func,
  confirmDeleteSharedToken: PropTypes.func,
  clickIcon: PropTypes.func,
  mouseLeaveIcon: PropTypes.func,
  clickedIcon: PropTypes.bool,
  successText: PropTypes.string,
  timezone: PropTypes.string,
  styles: PropTypes.object
};

export default themeable(SharedLinkRow);
